import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { orgMember } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useCancelEnterpriseMembership = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_COMMERCE_HOSTNAME}organizations/backoffice/cancellation/cancel-membership/`, { ...attributes }, { ...params, timeout: 50000 }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [orgMember] });
        }
    });
};
export default useCancelEnterpriseMembership;
